import { render } from "./PRO_Clase.vue?vue&type=template&id=de38cc40&scoped=true&ts=true"
import script from "./PRO_Clase.vue?vue&type=script&lang=ts"
export * from "./PRO_Clase.vue?vue&type=script&lang=ts"

import "./PRO_Clase.vue?vue&type=style&index=0&id=de38cc40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de38cc40"]])

export default __exports__